module.exports = __webpack_public_path__ + "static/media/london.c7343e04.jpg";